import { isObject } from '../../../../motion-utils/dist/es/is-object.mjs';

/**
 * Checks if an element is an SVG element in a way
 * that works across iframes
 */
function isSVGElement(element) {
    return isObject(element) && "ownerSVGElement" in element;
}

export { isSVGElement };
